export default [
  {
    path: '/hires/:hireId',
    name: 'HireEditor',
    component: () => import('../../views/app/hire-editor/index.vue')
  }
]
